// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-tags[data-v-1ed2218c]{width:100%}@media(min-width:1200px){.footer-tags[data-v-1ed2218c]{padding-top:var(--padding-xl);padding-bottom:var(--padding-xl)}}.footer-tags__item[data-v-1ed2218c]{width:auto}.footer-tags__item[data-v-1ed2218c]:not(:last-of-type){margin-right:var(--spaces-m)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
